import serviceimg from '../../../assets/images/SServices.png';
import PageHeader from '@/components/PageHeader';


function BusinessDevelopmentServices() {
  return (
    <div className="font-sans">

      <PageHeader title='Our Services' imageUrl={serviceimg} breadcrumbs={['Home', 'Our Services', 'Pharmaceutical Product Development & Project Management', 'Business Development Services']} />

      <div className="max-w-[var(--max-width)] mx-auto px-4 sm:px-6 md:px-12 lg:px-20 xl:px-32 py-12 text-[#05326D]">

        <h2 className="text-xl font-bold text-[#05326D] flex items-center gap-2 mb-12">
          <span className="inline-block w-[6px] h-5 rounded-tr-sm rounded-br-sm bg-[#B5AB28]"></span>
          Pharmaceutical Product Development & Project Management
        </h2>

        <div className="flex items-center gap-2 mb-4">
          <span className="w-4 h-4 rounded-full bg-sky-300 flex-shrink-0"></span>
          <h3 className="text-lg font-bold text-[#05326D]">
            Business Development Services
          </h3>
        </div>

        {/* Intro */}
        <p className="text-sm text-[#05326D] mb-2 font-bold">
          Strategic Partnerships & Global Expansion for the Generic Pharmaceutical Industry
        </p>
        <p className="mb-4 text-sm text-[#05326D]">
          The global generic pharmaceutical sector continues to offer vast opportunities for growth through strategic partnerships, contract manufacturing, licensing, and product development. At FDAC Consultancy, we leverage our extensive network of small, medium, and large pharmaceutical organizations to help clients unlock new business avenues across both regulated and emerging markets.
        </p>
        <p className="mb-8 text-sm text-[#05326D]">
          Our business development services are designed to accelerate international expansion, optimize supply chains, and foster long-term collaborations.
        </p>

        <hr className="border-t border-gray-300 mb-8" />

        {/* Core Business Development Solutions */}
        <div className="flex items-center gap-2 mb-4 mt-4">
          <div className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0"></div>
          <span className="text-md font-bold text-[#05326D]">
            Our Core Business Development Solutions
          </span>
        </div>
        <p className="ml-2 mt-2 text-[#05326D]">Global Distribution Partnerships: Identification and onboarding of reliable partners for product distribution across key markets.</p>
        <p className="ml-2 mt-2 text-[#05326D]">Product Development & Commercialization: Support from concept to market launch, including regulatory alignment and marketing strategy.</p>
        <p className="ml-2 mt-2 text-[#05326D]">Contract Manufacturing & Supply Chain Partnerships: Sourcing and onboarding of GMP-compliant manufacturers for formulations and APIs.</p>
        <p className="ml-2 mt-2 text-[#05326D]">API, Excipients & Formulation Sourcing: Strategic procurement from qualified suppliers to ensure quality, compliance, and cost-efficiency.</p>
        <p className="ml-2 mt-2 text-[#05326D]">Regulatory Representation: Acting as your official company representative in both US and India, facilitating regulatory communication and submissions.</p>
        <p className="ml-2 mt-2 text-[#05326D]">Clinical Trial & Bioequivalence (BE) Partnerships: Connecting clients with trusted CROs for clinical development and BE studies.</p>
        <p className="ml-2 mt-2 text-[#05326D]">EU Batch Release & Testing Site Coordination: Facilitating batch release and analytical testing through certified EU-based facilities.</p>


        {/* Why FDAC */}
        <div className="flex items-center gap-2 mb-4 mt-4">
          <div className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0"></div>
          <span className="text-md font-bold text-[#05326D]">
            Why FDAC?
          </span>
        </div>
        <p className="ml-2 mt-2 text-[#05326D]">Deep industry relationships across global markets</p>
        <p className="ml-2 mt-2 text-[#05326D]">Proven expertise in regulatory, technical, and commercial domains</p>
        <p className="ml-2 mt-2 text-[#05326D]">Agile support for both early-stage and mature product portfolios</p>
        <p className="ml-2 mt-2 text-[#05326D]">Commitment to quality, confidentiality, and strategic growth</p>

      </div>
    </div>
  );
}

export default BusinessDevelopmentServices;
